<template>
  <div class="main-pcLineasPedidoVentaOrdenYParteProduccion">
    <div>
      <!-- Lineas Pedido Venta Filter -->
      <div class="content-filter-fixed">
        <div class="content-filter padding-half">
          <div>
            <span class="content-filter__title">
              {{ $t('common.departureDateShort') }}
            </span>
            <UCDatePicker
              id="1"
              @onchange="ChangedDateQuery"
            />
          </div>
          <div>
            <span class="content-filter__title">
              {{ $t('common.productionLine') }}
            </span>
            <UCSearchEntityERP
              class="content-filter-search__ucSearch"
              :placeholder="$t('common.productionLine')"
              :search-text="$t('searchEntity.line.searchText')"
              :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
              :default-value="lineaDeProduccionSeleccionada"
              :default-etities-list="lineasProduccion"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :property-entity-shown-list-title="['Codigo']"
              :property-entity-shown-list-subtitle="['Nombre']"
              :min-text-search="0"
              :emit-evet-change-default-value="true"
              @selection="LineaProduccionSeleccionada"
            />
          </div>
        </div>
        <div class="content-filter-search padding-horizontal-half padding-bottom-half">
          <div>
            <span class="content-filter-search__title">
              {{ $t('common.customer') }}
            </span>
            <UCSearch
              ref="UCSearchCliente"
              :placeholder="$t('common.customer')"
              :min-length="0"
              :find-on-change="true"
              class="client-search"
              @change="EventFilterSelected(1, $event)"
              @search-bar-value-changed="EventFilterSelected(1, $event)"
            />
          </div>
          <div>
            <span class="content-filter-search__title">
              {{ $t('common.product') }}
            </span>
            <UCSearch
              ref="UCSearchProducto"
              :placeholder="$t('common.product')"
              :min-length="0"
              :find-on-change="true"
              class="product-search"
              @change="EventFilterSelected(2, $event)"
              @search-bar-value-changed="EventFilterSelected(2, $event)"
            />
          </div>
          <div>
            <span class="content-filter-search__title">
              {{ $t('common.package') }}
            </span>
            <UCSearch
              ref="UCSearchEnvase"
              :placeholder="$t('common.package')"
              :min-length="0"
              :find-on-change="true"
              class="packaging-search"
              @change="EventFilterSelected(3, $event)"
              @search-bar-value-changed="EventFilterSelected(3, $event)"
            />
          </div>
          <div>
            <span class="content-filter-search__title">
              {{ $t('common.references') }}
            </span>
            <UCSearch
              ref="UCSearchReference"
              :placeholder="$t('common.references')"
              :min-length="0"
              :find-on-change="true"
              class="reference-search"
              @change="EventFilterSelected(4, $event)"
              @search-bar-value-changed="EventFilterSelected(4, $event)"
            />
          </div>
        </div>
        <div class="content-selection">
          <img
            v-if="allSelec"
            :src="icCheckOn"
            alt="iconCheckOn"
            width="18"
            height="18"
            @click="AllSelected"
          >
          <img
            v-else
            :src="icCheckOff"
            alt="iconCheckOff"
            width="18"
            height="18"
            @click="AllSelected"
          >
          <span class="span-selection padding-horizontal">
            {{ $t('common.selectAll') }}
          </span>
        </div>
      </div>

      <UCPreload :show="showPreload" />

      <!-- Lineas Pedido Venta Resultados -->
      <f7-list
        media-list
        class="content-lineas-pedido-venta-orden-parte-list"
      >
        <f7-list-item
          v-for="(item, index) in listaFiltros"
          :key="index"
          :title="
            `${item.LineaPedidoVenta.PedidoVenta.Serie} / ${item.LineaPedidoVenta.PedidoVenta.Numero} - ${item.LineaPedidoVenta.Orden} ${item.LineaPedidoVenta.PedidoVenta.Cliente.Nombre}`
          "
          @click="OrderLineSelection(item)"
        >
          <template #subtitle>
            <div class="content-lineas-pedido-venta-orden-parte-list__data">
              <div>
                <span class="orden-parte-item-title">{{ `${$t('common.product')}:` }}
                  <span class="orden-parte-item-name"> {{ item.Producto.Nombre }} </span>
                </span>
              </div>
              <div>
                <span class="orden-parte-item-title">{{ `${$t('common.package')}:` }}
                  <span class="orden-parte-item-name"> {{ item.Envase.Nombre }} </span>
                </span>
              </div>
              <div>
                <span class="orden-parte-item-title">{{ `${$t('common.pallet')}:` }}
                  <span class="orden-parte-item-name"> {{ item.Pale.Nombre }} </span>
                </span>
              </div>
              <div>
                <span class="orden-parte-item-title">{{ `${$t('common.referenceShort')}:` }}
                  <span class="orden-parte-item-name"> {{ item.LineaPedidoVenta.PedidoVenta.Referencia }} </span>
                </span>
              </div>
            </div>
            <div class="content-lineas-pedido-venta-orden-parte-list__quantity">
              <span
                v-if="item.ParteProduccion"
                class="orden-parte-item-title  display-flex justify-content-flex-end"
              >
                {{ `${$t('common.parts')}:` }} <span
                  class="orden-parte-item-name"
                > {{ `${item.ParteProduccion.Serie} / ${item.ParteProduccion.Numero}` }}
                </span>
              </span><span v-else />
              <span class="orden-parte-item-palet  display-flex justify-content-flex-end">
                <img
                  class="content-lineas-pedido-venta-orden-parte-list__img"
                  width="20px"
                  alt="iconPale"
                  src="@/static/icons/ic_palet_2.svg"
                >
                {{ item.LineaPedidoVenta.CantidadPales }}
                <img
                  class="content-lineas-pedido-venta-orden-parte-list__img"
                  width="20px"
                  alt="iconBox"
                  src="@/static/icons/ic_box_blue.svg"
                >
                {{ item.LineaPedidoVenta.CantidadEnvases }}
              </span>
            </div>
          </template>
          <template #media>
            <div
              class="margin-top"
              :class="{ 'no-media': item.ParteProduccion !== null }"
            >
              <div v-if="item.ParteProduccion === null">
                <img
                  v-if="item.Seleccionada === true"
                  :src="icCheckOn"
                  width="18"
                  height="18"
                >
                <img
                  v-else
                  :src="icCheckOff"
                  alt="iconCheckOff"
                  width="18"
                  height="18"
                >
              </div>
            </div>
          </template>

          <template #after>
            <div>
              <img
                src="@/static/icons/ic_options.svg"
                width="24"
                height="24"
                alt="iconOption"
                @click="MostrarPopupOpcionesLineaPedido(item)"
              >
            </div>
          </template>
        </f7-list-item>
      </f7-list>
      <!-- ************* BOTON ************** -->
      <div class="content-lineas-pedido-venta-orden-parte-button padding-half">
        <f7-button
          fill
          @click="EventListaSeleccionada()"
        >
          {{ $t('common.confirm') }}
        </f7-button>
      </div>
    </div>

    <UCConfirmation ref="confirmacionPedidosSeleccionados" />

    <f7-popup
      v-if="popupMostrarPopupOpcionesLineaPedido"
      class="content-lineas-produccion-orden-parte-popup"
      :opened="popupMostrarPopupOpcionesLineaPedido"
      @popup:closed="popupMostrarPopupOpcionesLineaPedido = false"
    >
      <TheNavbar
        :style="appTheme"
        :nav-title="$t('production.manageProductionLines.salesOrderLinesPopup.infoPopup.title', {
          serial: lineaPedidoSeleccionada.Serie,
          number: lineaPedidoSeleccionada.Numero,
        })"
        :popup-close-btn-enable="true"
      />
      <f7-block>
        <div class="content-lineas-produccion-orden-parte-popup-data">
          <span
            class="content-lineas-produccion-orden-parte-popup-data__title"
          >
            {{ $t('common.otherDataPl') }}
          </span>
          <span class="orden-parte-item-title padding-half">{{ `${$t('common.brand')}:` }}
            <span class="orden-parte-item-name"> {{ lineaPedidoSeleccionada.Marca?.Nombre ?? '' }} </span> </span>
          <span class="orden-parte-item-title padding-half">{{ $t('production.manageProductionLines.salesOrderLinesPopup.infoPopup.other.deliveryAddress') }}
            <span class="orden-parte-item-name"> {{ lineaPedidoSeleccionada.DireccionEnvio }} </span> </span>
        </div>
        <div
          v-if="lineaPedidoSeleccionada.ParteProduccionPrevistoSalida != null"
          class="content-lineas-produccion-orden-parte-popup-list  padding-top"
        >
          <span class="content-lineas-produccion-orden-parte-popup-list__title">
            {{ $t('production.manageProductionLines.salesOrderLinesPopup.infoPopup.distributions.title') }}
          </span>
          <div class="content-lineas-produccion-orden-parte-popup-list__list">
            <f7-list media-list>
              <f7-list-item
                v-for="(linea, i) in lineaPedidoSeleccionada.ParteProduccionPrevistoSalida"
                :key="i"
                class="content-lineas-produccion-orden-parte-popup-list__list-item"
                :title="linea.LugarProduccion !== null ? linea.LugarProduccion.Nombre : (linea.LineaProduccion !== null ? linea.LineaProduccion.Nombre : '')"
                :subtitle="`${$t('common.part')}: ${linea.ParteProduccionPrevisto.ParteProduccion.Serie} / ${linea.ParteProduccionPrevisto.ParteProduccion.Numero}`"
              >
                <template #after>
                  <span class="orden-parte-item-palet  display-flex justify-content-flex-end">
                    <img
                      class="content-lineas-pedido-venta-orden-parte-list__img padding-right-half"
                      width="20px"
                      alt="iconPale"
                      src="@/static/icons/ic_palet_2.svg"
                    >
                    {{ `${linea.Cantidad} ${$t('common.of')} ${lineaPedidoSeleccionada.CantidadPales}` }}
                  </span>
                </template>
              </f7-list-item>
            </f7-list>
          </div>
        </div>
      </f7-block>
    </f7-popup>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { LogDetails as Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import icCheckOn from '@/static/icons/ic_checked_on.svg';
import icCheckOff from '@/static/icons/ic_checked_off.svg';
import TheNavbar from '@/components/TheNavbar.vue';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';
import UCSearch from '@/components/common/UCSearch.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import UCPreload from '@/components/common/UCPreload.vue';

export default {
  name: 'PCLineasPedidoVentaOrdenYParteProduccion',
  components: {
    UCDatePicker,
    UCSearch,
    UCPreload,
    TheNavbar,
    UCSearchEntityERP,
    UCConfirmation,
  },

  data() {
    return {
      lineaPedidoSeleccionada: {}, // tarjeta que seleccionamos
      lineasProduccion: null,
      mainData: [],
      listaFiltros: [], // Lista de los filtros
      listaSelect: [], // lista de lineas seleccionadas
      optionsSelected: false, // Para solo mostrar el Popup o las Cantidades reservadas por Linea
      popupMostrarPopupOpcionesLineaPedido: false, // Para mostrar el popup
      showPreload: false,
      dateQuery: null,
      statusRequestTypes: {
        SINRESERVA: 0, // No hay ninguna cantidad reservada
        PARCIALMENTERESERVADO: 1, // Hay alguna cantidad reservada pero no la totalidad
        TOTALMENTERESERVADO: 2, // Se ha reservado la cantidad pedida totalmente
        NOTOTALMENTERESERVADO: 3, // Es la unión de Sin Reserva y Parcialmente Reservado.
        TODOS: 4, // Es la unión de Sin Reserva Parcialmente Reservado y Totalmente reservado.
      },
      statusRequest: 0,
      icCheckOn,
      icCheckOff,
      allSelec: false,
    };
  },

  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-dark-blue)',
        '--f7-navbar-text-color': '#fff',
      };
    },
    ...mapState(useTraceabilityStore, [
      'getLineasProduccion',
      'lineaDeProduccionSeleccionada',
    ]),
  },
  created() {
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.lineasProduccion = this.getLineasProduccion;
      this.lineaSeleccionada = this.lineaDeProduccionSeleccionada;
      this.statusRequest = this.statusRequestTypes.TODOS;
      const dateNow = new Date();
      this.dateQuery = `${dateNow.getFullYear()}/${dateNow.getMonth() + 1}/${dateNow.getDate()}`;
      // this.GetData();
    },
    /** @public */
    ClearElementSelected() {
      Log(this, this.ClearElementSelected.name);
      this.OrderLineSelection(null);
    },
    GetMainData(filter) {
      Log(this, this.GetMainData.name);
      this.mainData = [];
      this.GETDataSalesOrderLine(filter);
    },

    ActualizarDatos() {
      Log(this, this.ActualizarDatos.name);
      this.listaSelect = this.listaFiltros;

      this.GetData();
    },

    ObtenerLista(listaActualizada) {
      Log(this, this.ObtenerLista.name);

      for (let i = 0; i < listaActualizada.length; i += 1) {
        if (this.listaSelect.length > 0) {
          if (this.listaSelect[i].LineaPedidoVenta.Id === listaActualizada[i].LineaPedidoVenta.Id) {
            this.listaFiltros[i] = this.listaSelect[i];
          } else {
            this.listaFiltros[i].Seleccionada = false;
          }
        }
      }
    },

    ChangedDateQuery(newValue) {
      Log(this, this.ChangedDateQuery.name);
      let stringDate = '';
      if (newValue !== '') {
        stringDate = `${newValue.getFullYear()}/${newValue.getMonth() + 1}/${newValue.getDate()}`;
        this.dateQuery = stringDate;

        this.GetData();
      } else {
        this.listaFiltros = null;
      }
    },

    GetData() {
      Log(this, this.GetData.name);
      const filter = {
        FechaConsulta: this.dateQuery,
        EstadoLineaPedido: this.statusRequest,
      };
      this.GetMainData(filter);
    },

    ChangedDateFilter(newDateValue) {
      Log(this, this.ChangedDateFilter.name);
      this.activityList = this.activityListOrigin;
      this.activityList = this.activityList.filter((e) => e.FechaInicio.includes(newDateValue));
    },

    OrderLineSelection(value) {
      Log(this, this.OrderLineSelection.name);
      if (!this.optionsSelected) {
        if (value.ParteProduccion !== null) {
          HiNotification.Toast(this.$t('production.info.thisLineAlreadyHasProductionOrder'));
          return;
        }
        // cambia el valor de Seleccionada de la tarjeta seleccionada
        const foundItem = this.listaFiltros.find((f) => f.LineaPedidoVenta.Id === value.LineaPedidoVenta.Id);
        foundItem.Seleccionada = !foundItem.Seleccionada;

        // comprobamos si están todas seleccionadas o no
        const allSelected = this.listaFiltros.findIndex((f) => !f.Seleccionada) === -1;
        this.allSelec = allSelected;
      }
      this.optionsSelected = false;
    },

    EventListaSeleccionada() {
      Log(this, this.EventListaSeleccionada.name);
      const tempListaSelected = this.listaFiltros.filter((s) => s.Seleccionada === true);
      let idsLineasPedidoVenta = '';

      tempListaSelected.forEach((linea, i) => {
        idsLineasPedidoVenta += `${linea.IdLineaPedidoVenta}`;

        if (i < tempListaSelected.length - 1) {
          idsLineasPedidoVenta += ',';
        }
      });

      if (idsLineasPedidoVenta === '') {
        HiNotification.Toast(this.$t('production.info.noSalesOrdersWithoutProductionPart'));
      } else {
        this.$refs.confirmacionPedidosSeleccionados.create(
          this.$t('production.info.confirmSalesOrderLines.title').toUpperCase(),
          this.$t('production.info.confirmSalesOrderLines.text'),
          () => {
            this.CrearOrdenYPartePorLineaPedido(this.lineaSeleccionada.Id, idsLineasPedidoVenta)
              .then(() => {
                this.ActualizarDatos();
                this.$refs.UCSearchCliente.Clear();
                this.$refs.UCSearchProducto.Clear();
                this.$refs.UCSearchEnvase.Clear();
                this.$refs.UCSearchReference.Clear();
              })
              .catch((error) => {
                HiNotification.Toast(error);
              });
          },
        );
        this.$refs.confirmacionPedidosSeleccionados.show();
      }
    },

    LineaProduccionSeleccionada(lineaSeleccionada) {
      Log(this, this.LineaProduccionSeleccionada.name);
      this.lineaSeleccionada = lineaSeleccionada;
    },

    //* ************************ FILTROS  ************************** */
    EventFilterSelected(type, val) {
      Log(this, this.EventFilterSelected.name);

      if (val !== null) {
        if (val === '') {
          this.listaFiltros = this.mainData;
        }

        switch (type) {
          case 1:
            this.listaFiltros = this.listaFiltros.filter(
              (e) => e.LineaPedidoVenta != null
                && e.LineaPedidoVenta.PedidoVenta.Cliente.Nombre.toString()
                  .toLowerCase()
                  .includes(val.toLowerCase()),
            );
            break;
          case 2:
            this.listaFiltros = this.listaFiltros.filter(
              (e) => e.Producto.Nombre.toString()
                .toLowerCase()
                .includes(val.toLowerCase()),
            );
            break;
          case 3:
            this.listaFiltros = this.listaFiltros.filter(
              (e) => e.Envase.Nombre.toString()
                .toLowerCase()
                .includes(val.toLowerCase()),
            );
            break;
          case 4:
            this.listaFiltros = this.listaFiltros.filter(
              (e) => e.LineaPedidoVenta != null
                && e.LineaPedidoVenta.PedidoVenta.Referencia.Nombre.toString()
                  .toLowerCase()
                  .includes(val.toLowerCase()),
            );
            break;
          default:
            break;
        }
      } else {
        this.listaFiltros = null;
      }
    },
    //* *************************** POPUP **************************************** */
    MostrarPopupOpcionesLineaPedido(items) {
      Log(this, this.MostrarPopupOpcionesLineaPedido.name);
      this.optionsSelected = true;
      this.lineaPedidoSeleccionada = {
        Serie: items.LineaPedidoVenta.PedidoVenta.Serie,
        Numero: items.LineaPedidoVenta.PedidoVenta.Numero,
        Marca: items.Marca,
        DireccionEnvio: items.DireccionDeEnvio,
        ParteProduccionPrevistoSalida: items.ParteProduccionPrevistoSalida,
        CantidadPales: items.LineaPedidoVenta.CantidadPales,
      };

      this.popupMostrarPopupOpcionesLineaPedido = true;
    },

    AllSelected() {
      Log(this, this.AllSelected.name);
      this.allSelec = !this.allSelec;
      this.listaFiltros.forEach((i) => {
        if (i.ParteProduccion === null) {
          i.Seleccionada = this.allSelec;
        }
      });
    },

    async GETDataSalesOrderLine(filter) {
      Log(this, this.GETDataSalesOrderLine.name);
      this.showPreload = true;
      this.listaFiltros = [];

      await callExecuteSPERP(
        'APPERPAGRO_LineasPedidoVentaParaParteYOrdenProduccion',
        [
          { NombreParametro: 'fechaSalidaDesde', Valor: filter.FechaConsulta },
          { NombreParametro: 'fechaSalidaHasta', Valor: filter.FechaConsulta },
        ],
        'Trazabilidad.PedidoPlanificadoParaPaletizadoJSON',
      ).then((result) => {
        this.showPreload = false;

        if (result.status === 200) {
          this.mainData = result.data;

          const temp = [];
          this.mainData.forEach((e) => {
            if (!temp.includes(e.IdLineaPedidoVenta)) {
              temp.push(e.IdLineaPedidoVenta);
              const lista = {
                IdLineaPedidoVenta: e.IdLineaPedidoVenta,
                LineaPedidoVenta: e.LineaPedidoVenta,
                ParteProduccionPrevistoSalida: e.ParteProduccionPrevistoSalida !== null ? [e.ParteProduccionPrevistoSalida] : e.ParteProduccionPrevistoSalida,
                Producto: e.Producto,
                Envase: e.Envase,
                Pale: e.Pale,
                DireccionDeEnvio: e.DireccionDeEnvio,
                Marca: e.Marca,
                ParteProduccion: e.ParteProduccion,
              };

              this.listaFiltros.push(lista);
            } else {
              this.listaFiltros.forEach((l) => {
                if (l.IdLineaPedidoVenta === e.IdLineaPedidoVenta) {
                  l.ParteProduccionPrevistoSalida.push(e.ParteProduccionPrevistoSalida);
                }
              });
            }
          });
          // if (this.listaSelect !== null) this.ObtenerLista(this.listaFiltros);
        } else {
          HiNotification.Toast(result.Mensaje || this.$t('production.info.couldNotQuerySalesOrderInformation'));
        }
      });
    },

    CrearOrdenYPartePorLineaPedido(idLineaProduccion, idsLineaPedidoVenta) {
      Log(this, this.CrearOrdenYPartePorLineaPedido.name);
      HiDialog.Preloader(true, this.$t('production.info.creatingOrderAndProductionPart'));
      return new Promise((resolve, reject) => {
        ConexionTA.callCrearOrdenYPartePorLineaPedido(idLineaProduccion, idsLineaPedidoVenta)
          .then((result) => {
            HiDialog.Preloader(false);
            if (result.Valor) {
              resolve(result.Tag);
            } else {
              reject(result.Mensaje);
            }
          })
          .catch((error) => {
            HiDialog.Preloader(false);
            reject(error);
            LogError(this, this.CrearOrdenYPartePorLineaPedido.name, error);
          });
      });
    },
  },
};
</script>

<style lang="scss">
.main-pcLineasPedidoVentaOrdenYParteProduccion {
  background-color: var(--his-tierra-white);
  --search-input-height: 36px;
  --search-input-color: var(--his-dark-blue);
  --search-input-font-size: 16px;
  --search-input-padding: 0 8px;
  --search-btn-border-left: 0;
  --date-picker-input-height: var(--search-input-height);
  --date-picker-input-color: var(--search-input-color);
  --date-picker-input-font-size: var(--search-input-font-size);
  --date-picker-input-padding: var(--search-input-padding);

  .content-filter-fixed {
    position: fixed;
    top: var(--f7-navbar-height);
    z-index: 5;
    background-color: var(--his-tierra-white);
    width: 100%;
  }

  .content-filter {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 10px;

    > div {
      align-self: flex-end;
    }
  }

  .content-filter-search {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 10px;

    @media (max-width: 630px) {
      grid-template-columns: repeat(2, 1fr);
    }

    &__ucSearch {
      .margin-top-half {
        margin-top: 0 !important;
      }
    }

    form {
      background-color: #fff !important;

      > div {
        background-color: transparent !important;
      }

      input {
        background-color: transparent;
      }
    }
  }

  .content-filter,
  .content-filter-search {
    &__title {
      color: var(--his-slate-blue);
      margin: 8px;
    }

    .content-search-input input {
      &::placeholder {
        font-size: 13px;
        color: #a0a6b7;
      }
    }
  }

  .content-lineas-pedido-venta-orden-parte-list {
    margin-top: 230px;
    height: calc(100vh - 230px - 61px - var(--f7-navbar-height));
    overflow-y: scroll;

    @media (min-width: 630px) {
      margin-top: 180px;
      height: calc(690px - var(--f7-navbar-height) - 181px - 61px);
    }

    .item-media {
      min-width: 0;
      padding-top: 0;
    }

    .item-title-row {
      align-items: center;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 1;

      .item-title {
        color: #172b4d;
        font-size: 17px;
      }

      .item-after {
        height: 24px;
      }
    }

    .item-subtitle {
      color: var(--his-darkgray);
      display: grid;
      grid-template-columns: 2fr 1fr;
      grid-column-gap: 10px;

      .content-lineas-pedido-venta-orden-parte-list__img {
        padding-left: 10px;
        padding-right: 5px;
      }

      .content-lineas-pedido-venta-orden-parte-list__data {
        align-items: center;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 1;
      }

      .content-lineas-pedido-venta-orden-parte-list__quantity {
        display: grid;
        grid-template-rows: repeat(2, 1fr);
        align-items: flex-end;
      }
    }
  }

  .content-selection {
    padding: 8px var(--f7-typography-padding);
    display: flex;
    border-bottom: 1px solid var(--his-kiwi-pulp);

    .span-selection {
      color: var(--his-slate-blue);
      font-size: 14px;
    }
  }

  .content-lineas-pedido-venta-orden-parte-button {
    position: relative;
    bottom: 0;
    border-top: 1px solid var(--his-kiwi-pulp);
  }

  .no-media {
    padding-left: 20px;
  }
}

.orden-parte-item-title {
  color: var(--his-slate-blue);
  font-size: 15px;
  padding-right: 5px;
}

.orden-parte-item-palet {
  color: var(--his-slate-blue);
  font-size: 16px;
  font-weight: 600;
  padding-right: 5px;
}

.orden-parte-item-name {
  font-size: 13px;
  color: var(--his-kiwi-pulp);
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 1;
}

.content-lineas-produccion-orden-parte-popup {
  background: #fff;

  @media (min-width: 630px) {
    height: 690px !important;
    top: 46% !important;
  }

  .content-lineas-produccion-orden-parte-popup-data,
  .content-lineas-produccion-orden-parte-popup-list {
    display: flex;
    flex-direction: column;

    &__title {
      color: var(--his-oliva);
      font-size: 17px;
      border-bottom: 1px solid var(--his-slate-blue);
    }

    .item-title-row {
      align-items: center;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 1;

      .item-title {
        color: #172b4d;
        font-size: 17px;
      }
    }

    &__list {
      overflow-y: scroll;
    }
  }
}
</style>
